"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "LoadingPatientInfo", {
  enumerable: true,
  get: function () {
    return _PatientInfo.default;
  }
});
_Object$defineProperty(exports, "LoadingProvider", {
  enumerable: true,
  get: function () {
    return _Provider.default;
  }
});
var _Provider = _interopRequireDefault(require("./Provider"));
var _PatientInfo = _interopRequireDefault(require("./PatientInfo"));